import { useState } from 'react';
import useParticipantHoldingsStore from '../use-participant-holdings-store';
import useProfileCommonStore from '../use-profile-common-store';

const useSubNavBarStore = ({ navOptions }) => {
  const { apiConfigBase, commonState } = useProfileCommonStore();
  const { investButtonMode } = useParticipantHoldingsStore({ apiConfigBase, commonState }).data;
  const [selectedItem, setSelectedItem] = useState(navOptions[0] || {});
  const scrollSpyUpdate = (targetEl, navItems) => {
    if (targetEl && targetEl.id) {
      setSelectedItem(navItems.find(
        opt => opt.id === targetEl.id
      ));
    }
    return selectedItem;
  };
  return {
    handleScrollSpyUpdate: el => scrollSpyUpdate(el, navOptions),
    investButtonMode,
    selectedItem
  };
};

export default useSubNavBarStore;
